::ng-deep particle-check-in-dialog{width:100%}
/*# sourceMappingURL=check-in-dialog.component-JY6AKDF6.css.map */
